import React from "react";
import { getProducts } from "../../services/Api";
import ProductItem from "../../shared/components/product-item";

const Home = () => {
const [latestProduct, setLatestProduct] = React.useState([]);
const [featureProduct, setFeatureProduct] = React.useState([]);
React.useEffect(()=>{
    //set Latest Product
    getProducts({
        params: {
            limit:6,
        }
    }).then(({data})=>{
        setLatestProduct(data.data.docs);
    }).catch((error)=>console.log(error));
    //set Featured Product
    getProducts({
        params: {
            limit: 6,
            featured: true,
        }
    }).then(({data})=>{
        setFeatureProduct(data.data.docs);
    }).catch((error)=>console.log(error));
},[]);
    return (
        <>
            {/*	Feature Product	*/}
            <div className="products">
                <h3>Sản phẩm nổi bật</h3>
                <div className="product-list card-deck">
                    {
                        featureProduct?.map((product)=>{
                            return <ProductItem key={product._id} item={product}/>
                        })
                    }
                </div>
            </div>
            {/*	End Feature Product	*/}
            {/*	Latest Product	*/}
            <div className="products">
                <h3>Sản phẩm mới</h3>
                <div className="product-list card-deck">
                {
                        latestProduct?.map((product)=>{
                            return <ProductItem key={product._id} item={product}/>
                        })
                    }
                </div>
            </div>
            {/*	End Latest Product	*/}
        </>
    )
}
export default Home;